import { Component, Host, h, Prop, State, Listen, JSX } from '@stencil/core'

@Component({
    tag: 'zr-energy-label',
    styleUrl: 'zr-energy-label.scss',
    scoped: true,
})

/**
 * Energy efficiency class component.
 */
export class ZrEnergyLabel {
    /**
     * Property that defines energy level.
     */
    @Prop() energyLevel?: string = ''

    /**
     * Property that defines product details.
     */
    @Prop() productDetailsLabel?: string = 'Produktdatenblatt'

    /**
     * Property that shows the product detail information link.
     */
    @Prop() productDetailsLink?: string

    /**
     * Property that defines image.
     */
    @Prop() energyImage?: string

    /**
     * Property defines the figure caption.
     */
    @Prop() figcaption?: string

    /**
     * Property defines the modal headline.
     */
    @Prop() modalHeadline?: string

    /**
     * Store the state of the vx-modal component.
     */
    @State() isModalInView = false

    /**
     * Toggle the state of vx-modal component.
     *
     * @param {boolean} state
     */
    @Listen('inViewToggled')
    async handleModalClick(state: CustomEvent<boolean>) {
        this.isModalInView = state.detail
    }

    /**
     * Set the state of the vx-modal component.
     *
     * @param {boolean} state
     */
    private setModalState = (state: boolean) => {
        this.isModalInView = state
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class="zr-eec">

                    <a href="#"
                        class="zr-eec__level"
                        onClick={() => this.setModalState(true)}
                        title={this.energyLevel}
                    >
                        <span class={`is-level-${this.energyLevel}`}>
                            { this.energyLevel }
                        </span>
                    </a>

                    <a href={this.productDetailsLink}
                        class="zr-eec__link"
                        target="_blank"
                        title={this.productDetailsLabel}
                    >
                        {this.productDetailsLabel}
                    </a>

                </div>

                <vx-modal in-view={this.isModalInView}>
                    <h2 slot="headline">
                        {this.modalHeadline}
                    </h2>
                    <div slot="content">
                        <figure>
                            <img src={this.energyImage} alt={this.modalHeadline} />
                            {this.figcaption && <figcaption>{this.figcaption}</figcaption>}
                        </figure>
                    </div>
                </vx-modal>

            </Host>
        )
    }
}
